import { createSlice } from "@reduxjs/toolkit";

const playlistReleasesSlice = createSlice({
  name: "playlistReleases",
  initialState: {
    playlistReleases: [],
  },
  reducers: {
    setPlaylistReleases: (state, action) => {
      state.playlistReleases = action.payload;
    },
  },
});

export const { setPlaylistReleases } = playlistReleasesSlice.actions;

export default playlistReleasesSlice.reducer;
